import React from 'react'
import './styles.less'
import { useState, useEffect } from 'react'
import { getprojectInfo } from '../../redux/actions/projectOverview'
import ContentHeaderWidget from './ContentHeaderWidget'

export default function ContentHeader({
  header,
  subHeader,
  isNotCallApi,
  isShowGoButton = false,
  cleanSessions,
  projectCode = () => {},
  hideSubTitle = true,
}) {
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [subTitle, setSubTitle] = useState()

  useEffect(() => {
    !isNotCallApi && handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    try {
      const response = await getprojectInfo(projectId)

      if (response?.model?.projectCode) {
        let contractStr = ''

        if (response.model.projectContractNo) {
          contractStr = ` (${response.model.projectContractNoTitle} : ${response.model.projectContractNo}) `
        }

        let strCode = `${response.model.projectCodeTitle || 'รหัสโครงการ'} ${
          response.model.projectCode
        } ${contractStr || ''} : ${response.model.projectName ? response.model.projectName : ''}`

        projectCode(response.model.projectCode)

        setSubTitle(strCode)
      }
    } catch (e) {
      console.log('e', e)
    }
  }

  return (
    <ContentHeaderWidget
      header={header}
      subHeader={`${subTitle || subHeader || ''}`}
      isShowGoButton={isShowGoButton}
      cleanSessions={cleanSessions}
      hideSubHeader={!hideSubTitle}
    />
  )
}
